/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Fcorg} from '../models/fcorg.model';
import {ConfigService} from './config.service';

@Injectable({
  providedIn: 'root'
})
export class FcorgService {

  constructor(private readonly configService: ConfigService,
              private readonly http: HttpClient) {
  }

  /**
   * gets all fcorgs from API url
   * @return Observable<FcorgModel>
   */
  getAllFcorgs(): Observable<Fcorg[]> {
    return this.http.get<any>(`${this.configService.baseApiUrl}fcorgs`)
    .pipe(catchError(myError => this.handleError(myError)));
  }

  /**
   * gets fcorgs by id
   * @param gmid the users gmid
   */
  getFcorgsById(gmid: string) {
    const params = new HttpParams().set('gmid', gmid);
    return this.http.get<any>(`${this.configService.baseApiUrl}fcorgs/by-id`, {params})
    .pipe(catchError(myError => this.handleError(myError)));
  }

  /**
   * Handles the errors produced by the backend
   * @param errorResponse The error produced by the API to be handled by the frontend
   */
  private handleError(errorResponse: HttpErrorResponse): Observable<any> {
    let errorMessage = 'An unexpected error has occurred.';
    if (errorResponse.error && errorResponse.error.message) {
      errorMessage = errorResponse.error.message;
    }
    return throwError(errorMessage);
  }
}
